import { Component, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { ConfigureService } from '@app/configure/services/configure.service';

@Component({
	selector: 'cng-telephone-payment',
	templateUrl: './telephone-payment.component.html',
})
export class ConfigureTelephonePaymentComponent implements OnInit, OnDestroy {
	callback: any = this.configure_service.configure_data.meta.callback;
	creating_callback: boolean = false;

	destroyed$: Subject<boolean> = new Subject<boolean>();

	constructor(private configure_service: ConfigureService) {}

	ngOnInit(): void {
		this.configure_service.configure_data$.pipe(takeUntil(this.destroyed$)).subscribe((configure_data) => {
			this.callback = configure_data.meta.callback;
		});
	}

	showCallback(): void {
		this.creating_callback = true;
	}

	ngOnDestroy(): void {
		this.destroyed$.next(true);
	}
}
